import { CommissionFeeExtended } from "../interfaces/data";
import { UseCommissionFees } from "../interfaces/fetchers";
import { useSearch } from "./useSearch";

export const useCommissionFees = ({
  phrase,
  fields,
  extraOptions,
  filtersAndBetween,
  orderBy,
  orderDirection,
  offset,
  limit,
}: UseCommissionFees) => {
  const {
    data: fees,
    totalCount,
    pageCount,
    loading,
    error,
    refetch,
  } = useSearch<CommissionFeeExtended>({
    collection: "commission-fees/fees",
    phrase,
    extraOptions,
    filtersAndBetween,
    fields,
    orderBy,
    orderDirection,
    offset,
    limit,
    skipAutoUpdate: true,
  });

  return {
    fees,
    totalCount,
    pageCount,
    loading,
    error,
    refetch,
  };
};
